import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Two-letter avatar initials from an email address. */
export function initialsFor(email: string | null): string {
  return email ? email.split("@")[0].slice(0, 2).toUpperCase() : "?";
}
